import './Avatar-61b19061.css';

var classes = {"Avatar":"prc-Avatar-Avatar-ZRS-m"};

export { classes as default };
